import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const ShortCoursesHeader = ({ componentData }) => {
  // Use componentData from CMS if available, otherwise use defaults
  const title = componentData?.title || "Short";
  const subtitle = componentData?.subtitle || "Course";
  const content = componentData?.content || "Learn. Grow. Achieve.";
  const backgroundImage = componentData?.mediaUrl || "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=2072&q=80";

  return (
    <CourseHeader
      title={title}
      highlight={subtitle}
      subtitle={content}
      backgroundImage={backgroundImage}
      cta={{ label: "Start Application", targetId: "application-form" }}
    />
  );
};

export default ShortCoursesHeader;
